import { type Variants } from 'framer-motion';

/**
 * Standard gentle appearance animations used across the portal.
 * Provides a subtle stagger, fade-in, and slide-up effect.
 */

export const APPEAR_CONTAINER: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.12,
      delayChildren: 0.05
    }
  }
};

export const APPEAR_ITEM: Variants = {
  hidden: { opacity: 0, y: 16 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.25, 0.1, 0.25, 1]
    }
  }
};

/**
 * Simplified entrance animation for individual cards or standalone elements.
 */
export const APPEAR_SINGLE = {
  initial: { opacity: 0, y: 16 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.6, ease: [0.25, 0.1, 0.25, 1] }
};
